const PC900B = () => {
  return (
    <ul className="text-left">
      <li>
        <span>1.</span> Be sure the CMI PC-900B USB cable is connected securely to your computer.
      </li>
      <li>
        <span>2.</span> Be sure the device is fully powered on (press and hold power button if not)
      </li>
    </ul>
  )
}

export default PC900B
